module.exports = __webpack_public_path__ + "static/media/settingsIcon.39636569.svg";